import '@/assets/styles/reset.css'
import '@/assets/styles/global.scss'
import '@/assets/styles/base.scss'
import '@/assets/iconfonts/bwoil-kl/iconfont.css'
import '@/assets/iconfonts/bwoil-kl/iconfont.js'
import '@kuailu/sso/style'

import { createApp } from 'vue'
import App from './App.vue'
import { setupRouter } from './router'
import { setupStore, useCacheStore, useSSOStore } from './store'
import { setupI18n } from './i18n'
import { setupUiApi } from './utils'
import { setUpDefaultImg } from './directives/defaultImg'
import SSOClient from '@kuailu/sso'
import '@kuailu/common-components/style.css'

async function bootstrap() {
  const app = createApp(App)
  // 初始化 pinia
  setupStore(app)

  // 全局挂在 message, Dialog
  setupUiApi(app)
  useCacheStore()
  useSSOStore().init()
  const i18n = await setupI18n()
  if (hasError()) return
  app.use(i18n)
  // 初始化 路由
  await setupRouter(app)

  setUpDefaultImg(app)
  SSOClient.stateManager.hideLoading()
  app.mount('#app')
}

const hasError = () => {
  if (SSOClient.stateManager.hasError) {
    SSOClient.stateManager.hideLoading()
    SSOClient.stateManager.showError()
    return true
  }
  return false
}

bootstrap().then(() => {})
